import React, { useState } from 'react'
import { Box, Tabs, Tab } from '@mui/material'
import PageHeader from '../components/ui/PageHeader'
import EmailProvidersTab from '../components/email/EmailProvidersTab'
import EmailNotificationSettingsTab from '../components/email/EmailNotificationSettingsTab'
import EmailTemplatesTab from '../components/email/EmailTemplatesTab'
import EmailTestMessageTab from '../components/email/EmailTestMessageTab'

interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
}

const TabPanel: React.FC<TabPanelProps> = ({ children, index, value }) => (
  <Box role="tabpanel" hidden={value !== index} sx={{ pt: 3 }}>
    {value === index && children}
  </Box>
)

const EmailConfigurationPage: React.FC = () => {
  const [tab, setTab] = useState(0)

  return (
    <Box>
      <PageHeader
        title="Email"
        subtitle="Single source of truth for email providers, notification settings, templates, and test sends"
      />

      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={tab} onChange={(_, v) => setTab(v)}>
          <Tab label="Providers" />
          <Tab label="Notification Settings" />
          <Tab label="Templates" />
          <Tab label="Test Messages" />
        </Tabs>
      </Box>

      <TabPanel value={tab} index={0}>
        <EmailProvidersTab />
      </TabPanel>
      <TabPanel value={tab} index={1}>
        <EmailNotificationSettingsTab />
      </TabPanel>
      <TabPanel value={tab} index={2}>
        <EmailTemplatesTab />
      </TabPanel>
      <TabPanel value={tab} index={3}>
        <EmailTestMessageTab />
      </TabPanel>
    </Box>
  )
}

export default EmailConfigurationPage
